const comments = [
  {
    name: '影迷小张',
    time: '2小时前',
    rating: 5,
    content: '用了宅男视频快一年了，91视频和97视频的资源更新速度是真的快。高清画质加上不卡顿的播放体验，比我之前用的几个平台都强，已经推荐给身边的朋友了。',
  },
  {
    name: '深夜追剧人',
    time: '5小时前',
    rating: 5,
    content: '51视频网站的经典内容在这里都能找到，分类清晰，搜索方便。最重要的是免费资源多，清晰度也不打折扣，晚上躺床上投屏到电视看，体验感拉满。',
  },
  {
    name: '数码控阿杰',
    time: '8小时前',
    rating: 4,
    content: '作为一个数字视频平台的深度用户，宅男视频的播放流畅度确实超出预期。CDN加速效果明显，即使在晚高峰时段也能稳定播放，这个技术实力值得点赞。',
  },
  {
    name: '假期宅家党',
    time: '1天前',
    rating: 5,
    content: '放假在家无聊翻到了宅男视频，没想到91在线视频资源这么丰富。从热门大片到小众佳作都有覆盖，再也不用在多个App之间来回切换了，一站搞定所有观看需求。',
  },
  {
    name: '通勤追番族',
    time: '2天前',
    rating: 5,
    content: '移动端App做得相当不错，地铁上信号不好也能流畅播放。流量节省模式很实用，一天通勤看下来流量消耗也很少。97视频的新内容基本当天就能在宅男视频看到，更新速度很快。',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            用户评价
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-xl mx-auto">
            听听宅男视频用户怎么说
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {comments.slice(0, 3).map((comment) => (
            <div
              key={comment.name}
              className="p-5 md:p-6 rounded-lg bg-background-50 border border-background-200/70"
            >
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`ri-star-fill text-sm ${i < comment.rating ? 'text-accent-500' : 'text-background-300'}`}
                  ></i>
                ))}
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                {comment.content}
              </p>
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center">
                  <span className="text-xs font-bold text-primary-600">
                    {comment.name.charAt(0)}
                  </span>
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground-900">{comment.name}</p>
                  <p className="text-xs text-foreground-500">{comment.time}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6 mt-5 md:mt-6">
          {comments.slice(3, 5).map((comment) => (
            <div
              key={comment.name}
              className="p-5 md:p-6 rounded-lg bg-background-50 border border-background-200/70"
            >
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`ri-star-fill text-sm ${i < comment.rating ? 'text-accent-500' : 'text-background-300'}`}
                  ></i>
                ))}
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                {comment.content}
              </p>
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 rounded-full bg-secondary-200 flex items-center justify-center">
                  <span className="text-xs font-bold text-secondary-700">
                    {comment.name.charAt(0)}
                  </span>
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground-900">{comment.name}</p>
                  <p className="text-xs text-foreground-500">{comment.time}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}